<template>
  <div class="pulse-loader" aria-live="polite" aria-busy="true">
    <div class="circle --top"></div>
    <div class="circle --bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'PulseLoaderV2',
};
</script>

<style lang="scss" scoped>
@import "@ui-kit/styles/animations/_loader.scss";

$outer-circle-size: 28px;
$inner-circle-size: 16px;
$space-between-circles: calc(#{$outer-circle-size - $inner-circle-size} / 2);
$animation-duration: 2.44s;

.pulse-loader {
  min-width: $outer-circle-size;
  min-height: 2.12 * $outer-circle-size;
  position: relative;

  .circle {
    width: $outer-circle-size;
    height: $outer-circle-size;
    position: absolute;
    animation-name: float;
    transform-origin: center center;
    animation-duration: $animation-duration;
    animation-iteration-count: infinite;
    transform: scale(0.0); // initially the circles shouldn't be visible

    &:before,
    &:after {
      content: "";
      position: absolute;
      border-radius: 50%;
      transform-origin: center center;
      animation-duration: $animation-duration;
      animation-iteration-count: infinite;
    }

    &:before {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $loading-color;
      animation-name: shrink;
    }

    &:after {
      top: $space-between-circles;
      left: $space-between-circles;
      right: $space-between-circles;
      bottom: $space-between-circles;
      background-color: $background-color-normal;
      animation-name: shrink-faster;
    }

    &.--bottom {
      animation-delay: calc(#{$animation-duration} / 2);

      &:before,
      &:after {
        animation-delay: calc(#{$animation-duration} / 2);
      }
    }
  }
}
</style>
